import CollectionItemComponent from "./CollectionItemComponent";

export default CollectionItemComponent;